import api from "./utils/api";
import { getAuthToken } from "./utils/tokens";

// Generic API call wrapper with authentication
const authenticatedApiCall = async (endpoint) => {
  try {
    const token = getAuthToken();
    const response = await api.get(endpoint, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};

// Dashboard service functions - clean and DRY
const getSummary = () => authenticatedApiCall("/dashboard/summary");

const getDashboardOrders = () => authenticatedApiCall("/dashboard/orders");

const getDashboardUsers = () => authenticatedApiCall("/dashboard/users");

const getDashboardProducts = () => authenticatedApiCall("/dashboard/products");

const getDashboardCategories = () =>
  authenticatedApiCall("/dashboard/categories");

const getDashboardOffers = () => authenticatedApiCall("/dashboard/offers");

export {
  getSummary,
  getDashboardOrders,
  getDashboardUsers,
  getDashboardProducts,
  getDashboardCategories,
  getDashboardOffers,
};
